import { BefehlCard, SlideToUnlock, Befehl } from '@repo/ui'
import { useState } from 'react'
import { useBefehlMarkedAsDoneStore } from '../../../../store/useBefehlMarkedAsDoneStore'
import { useShallow } from 'zustand/react/shallow'
import MarkAuftraegeAsDoneProvider from '../../providers/MarkAuftraegeAsDoneProvider'

export interface BefehlCardTFProps {
  befehl: Befehl
  'data-testid': string
  onGelesen?: (id: string) => void
  isGelesen?: boolean
  showGelesenButton?: boolean
  befehlsnachrichtIsQuittiert?: boolean
  showBefehlAbgearbeitetSlideToUnlock?: boolean
  activateEmptyFieldWarnings?: boolean
}

export default function BefehlCardTf({
  befehl,
  'data-testid': testId,
  onGelesen,
  isGelesen = false,
  showGelesenButton = false,
  befehlsnachrichtIsQuittiert = false,
  showBefehlAbgearbeitetSlideToUnlock = false,
  activateEmptyFieldWarnings = false
}: Readonly<BefehlCardTFProps>) {
  const { setMarkedAsDone } = useBefehlMarkedAsDoneStore(
    useShallow((state) => ({
      setMarkedAsDone: state.setMarkedAsDone
    }))
  )

  const isDone = useBefehlMarkedAsDoneStore(
    (state) => state.markedAsDone[befehl.frontendId] || false
  )
  const [confirmed, setConfirmed] = useState<boolean>(isDone)

  const onSlideToUnlockChange = (value: boolean) => {
    setMarkedAsDone(befehl.frontendId, value)
    setConfirmed(value)
  }

  return (
    <MarkAuftraegeAsDoneProvider initialBefehlId={befehl.frontendId}>
      <BefehlCard
        befehl={befehl}
        data-testid={testId}
        isGelesen={isGelesen}
        onGelesen={onGelesen}
        befehlsnachrichtIsQuittiert={befehlsnachrichtIsQuittiert}
        displayHeaderOnly={confirmed && befehlsnachrichtIsQuittiert}
        showGelesenButton={showGelesenButton}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      >
        {befehlsnachrichtIsQuittiert && showBefehlAbgearbeitetSlideToUnlock && (
          <div
            className="border-t border-dotted -mx-1 mt-1"
            data-testid={`${testId}-abgearbeitet-markieren-slideToUnlock-wrapper-with-border`}
          >
            <div
              className="mt-1 ml-1 mr-1 sm:ml-2 sm:mr-2"
              data-testid={`${testId}-abgearbeitet-markieren-slideToUnlock-inner-wrapper`}
            >
              <SlideToUnlock
                data-testid={`${testId}-abgearbeitet-markieren-slideToUnlock`}
                confirmed={confirmed}
                onConfirmedChange={onSlideToUnlockChange}
              />
            </div>
          </div>
        )}
      </BefehlCard>
    </MarkAuftraegeAsDoneProvider>
  )
}
